// Dependencias
import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

// Componentes
import BannerFichas from '../../../components/BannerFichas/BannerFichas';
import Navbar from '../../../components/Navbar/Navbar';
import SessionBar from '../../../components/SessionBar/SessionBar';
import Footer from '../../../components/Footer/Footer';

// Funciones
import { ROUTES } from '../../../const/routes';
import { fetchUserData } from '../../../utils/api';

const MercadoPagoFailure = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [userData, setUserData] = useState(null);
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const monto = params.get('monto');
  const montoValido =
    monto == 1000 ||
    monto == 2000 ||
    monto == 5000 ||
    monto == 10000 ||
    monto == 20000 ||
    monto == 50000;

  useEffect(() => {
    fetchUserData(navigate, setUserData);
  }, [navigate]);

  return (
    <div>
      <BannerFichas />
      <div className="bg-gradient-to-b from-slate-950 to-violet-950 min-h-screen">
        <Navbar />
        <SessionBar />

        {montoValido ? (
          <div className="flex flex-col flex-grow items-center justify-center text-center py-10">
            <h2 className="text-2xl text-yellow-500 font-bold mb-4">
              {t('paymentFailure.title')}
            </h2>
            <p className="text-sm text-gray-300 mb-8">
              {t('paymentFailure.subtitle1')} <br />
              {t('paymentFailure.subtitle2')}
            </p>
            <div className="flex space-x-10">
              <div className="bg-bgContenedorOscuro border-solid border-4 border-borderContenedorOscuro shadow-shadowContenedorOscuro shadow-lg rounded-lg p-6 flex flex-col items-center">
                <p className="text-sm text-gray-300 mb-4 max-w-80">
                  {t('paymentFailure.loadingAmount')}
                </p>
                <h2 className="text-yellow-500 text-lg font-bold mb-2">
                  ${monto}
                </h2>
                <img
                  src={
                    ROUTES.rutaFichasPoker +
                    'FichaPoker' +
                    monto +
                    'Resized.png'
                  }
                  alt="Item"
                  className="w-60 object-cover mb-4"
                />
              </div>

              <div className="bg-bgContenedorOscuro border-solid border-4 border-borderContenedorOscuro shadow-shadowContenedorOscuro shadow-lg rounded-lg p-6 flex flex-col items-center w-max">
                <h2 className="text-yellow-500 text-lg font-bold mb-2 max-w-80">
                  {t('paymentFailure.errorTitle')}
                </h2>
                <p className="text-sm text-gray-300 mb-4 max-w-80">
                  {t('paymentFailure.errorMessage')}
                </p>
              </div>
            </div>
          </div>
        ) : (
          <div className="flex flex-col flex-grow items-center justify-center text-center py-10">
            <h2 className="text-2xl text-yellow-500 font-bold mb-4">
              {t('paymentFailure.unavailable')}
            </h2>
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
};

export default MercadoPagoFailure;
